import { get, find, values, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getReservationPending = get('reservation.pending');

export const getAll = createSelector(getReservationPending, get('all'));

export const getAllValues = createSelector(getAll, values);

export const getItemForBarcode = createSelector(
  (_, code) => ({ code }),
  getAllValues,
  find
);

export const getOrderedPending = createSelector(
  getAllValues,
  orderBy('id', 'desc')
);

export const getOrder = createSelector(getReservationPending, get('order'));

export const getIsFetching = createSelector(
  getReservationPending,
  get('fetching')
);
export const getIsFetched = createSelector(
  getReservationPending,
  get('fetched')
);

export const getFetchingError = createSelector(
  getReservationPending,
  get('fetchingError')
);

export const getIsSaving = createSelector(getReservationPending, get('saving'));

export const getIsSaved = createSelector(getReservationPending, get('saved'));
